import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-underground',
  templateUrl: './underground.component.html',
  styleUrls: ['./underground.component.scss']
})
export class UndergroundComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
